<template>

    <div class="bottom" style="">
        <!-- <div class="tel">{{$t('bottom.line')}}<a class="call-tel" href="tel:11 91186 8386">11 91186-8386</a></div> -->
        <div class="hyperLink">
            <a href="https://loggiponto.zendesk.com/hc/pt-br" target="_blank" rel="noopener noreferrer">{{ $t('bottom.support') }}</a>
        </div>
        <div class="bottom_content">
            <!-- <img src="../assets/image/index/Pakpobox logo.png"> -->
            <span>Copyright © {{ new Date().getFullYear() }} Alfred24 Tech Hong
                Kong Limited</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Bottom'
}
</script>

<style lang="less" scoped>
.bottom {
    margin-top: 0.1rem;
    width: 100%;
    height: 0.25rem;
    padding-bottom: 5px;
    // max-width: 400px;
    // left: 50% !important;
    // -webkit-transform: translateX(-50%);
    // transform: translateX(-50%);
}

.hyperLink {
    text-align: center;
    color: var(--primary-label-color);
    font-size: 0.18rem;
    font-weight: 400;
}

.hyperLink > a:hover {
    color: #1F8DC5;
    text-decoration: none;
    color: inherit;
}

.tel > a {
    text-decoration: none;
    color: inherit;
}

.call-tel {
    color: #1F8DC5;
    font-family: 'Poppins-Regular';
}

.bottom_content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 auto;

    img {
        position: relative;
        top: 0.01rem;
        width: 0.305rem;
        height: 0.06rem;
    }

    span {
        margin-left: 0.035rem;
        text-indent: 0;
        height: 0.07rem;
        margin-bottom: 0 !important;
        font-size: 0.06rem;
        font-weight: 400;
        color: #ACACAC;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue